module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/ula-parfienowicz-1fa2a436283ddaf7ec90dddec69b9b38.webp";